import React from 'react';
import { ProductImage } from './ui';
import { ShieldCheck, Lock } from 'lucide-react';
export const PricingSection = () => {
  return <section id="comprar" className="py-16 scroll-mt-8" data-id="element-36">
      <div className="text-center mb-10" data-id="element-37">
        <h2 className="text-3xl font-black text-[#1B3A5C] mb-4" data-id="element-38">
          La decisión es simple
        </h2>
        <p className="text-lg text-gray-700" data-id="element-39">Puedes seguir:</p>
        <ul className="text-gray-600 font-medium space-y-2 mt-4 mb-6" data-id="element-40">
          <li data-id="element-41">❌ Dudando</li>
          <li data-id="element-42">❌ Buscando información sin dirección</li>
          <li data-id="element-43">❌ Postergando</li>
        </ul>
        <p className="text-2xl font-black text-[#F47B20]" data-id="element-44">
          O puedes tomar acción hoy.
        </p>
      </div>

      <div className="bg-white rounded-3xl shadow-2xl border-2 border-[#F47B20] overflow-hidden max-w-lg mx-auto" data-id="element-45">
        <div className="bg-[#F47B20] text-white text-center py-3 font-bold tracking-widest text-sm" data-id="element-46">
          OFERTA POR TIEMPO LIMITADO
        </div>

        <div className="p-8 text-center" data-id="element-47">
          <ProductImage className="max-w-[200px] mb-6" data-id="element-48" />

          <h3 className="text-2xl font-black text-[#1B3A5C] mb-2" data-id="element-49">
            Motricidad en Niños
          </h3>
          <p className="text-gray-600 mb-6 font-medium" data-id="element-50">
            + 3 Bonos Exclusivos Gratis
          </p>

          <div className="flex flex-col items-center justify-center mb-8" data-id="element-51">
            <span className="text-gray-400 line-through text-2xl font-bold mb-1" data-id="element-52">
              $49.990
            </span>
            <div className="flex items-start" data-id="element-53">
              <span className="text-2xl font-bold text-green-600 mt-2 mr-1" data-id="element-54">
                $
              </span>
              <span className="text-6xl font-black text-green-600 tracking-tighter" data-id="element-55">
                19.990
              </span>
            </div>
            <span className="text-sm text-gray-500 mt-2 font-medium" data-id="element-56">
              Pesos Argentinos
            </span>
          </div>

          <a href="https://checkout.DigitalNek.shop/cart/48116818772203:1" className="block w-full bg-green-500 hover:bg-green-600 text-white font-black py-5 px-6 rounded-xl shadow-[0_8px_20px_0_rgba(34,197,94,0.4)] transform transition-all hover:scale-[1.02] active:scale-[0.98] text-xl md:text-2xl mb-4" data-id="element-57">
            QUIERO AYUDAR A MI HIJO HOY
          </a>

          <div className="flex items-center justify-center gap-2 text-sm text-gray-600 font-medium bg-gray-50 py-2 rounded-lg" data-id="element-58">
            <Lock className="w-4 h-4 text-green-600" data-id="element-59" />
            <span data-id="element-60">Pago 100% Seguro</span>
            <span className="mx-2" data-id="element-61">•</span>
            <span data-id="element-62">Acceso inmediato</span>
            <span className="mx-2" data-id="element-63">•</span>
            <span data-id="element-64">Descarga digital</span>
          </div>
        </div>
      </div>

      <div className="mt-16 text-center space-y-6 max-w-xl mx-auto" data-id="element-65">
        <h3 className="text-2xl font-black text-[#1B3A5C]" data-id="element-66">
          Porque cada día cuenta
        </h3>
        <p className="text-lg text-gray-700" data-id="element-67">
          Cada estímulo suma. Cada pequeño ejercicio construye. Cada momento
          importa.
        </p>
        <p className="text-xl font-bold text-[#F47B20]" data-id="element-68">Empieza hoy mismo</p>
        <p className="text-lg text-gray-700" data-id="element-69">
          Accede ahora a <span className="font-bold" data-id="element-70">Motricidad en Niños</span>{' '}
          y comienza a transformar el desarrollo de tu hijo desde casa, paso a
          paso.
        </p>

        <div className="bg-blue-50 p-6 rounded-2xl border border-blue-100 my-8" data-id="element-71">
          <p className="text-2xl font-black text-[#1B3A5C] mb-2" data-id="element-72">
            No necesitas ser perfecto
          </p>
          <p className="text-xl text-[#F47B20] font-bold" data-id="element-73">
            Solo necesitas empezar.
          </p>
        </div>

        <p className="text-lg text-gray-700 font-medium" data-id="element-74">
          Haz clic ahora y descubre cómo ayudar a tu hijo a avanzar con
          seguridad, confianza y alegría.
        </p>
        <p className="text-2xl font-black text-[#1B3A5C] mt-6" data-id="element-75">
          Porque su futuro… comienza con lo que haces hoy.
        </p>
      </div>
    </section>;
};